import TrustpilotHightlightsApp from '@/apps/TrustpilotHighlightsApp.vue'
import { createApp } from 'vue'

export default async function () {
  document.body
    .querySelectorAll('[data-trustpilot-highlights]')
    .forEach(async (el) => {
      createApp(TrustpilotHightlightsApp).mount(el)
    })
}
